module.exports = __webpack_public_path__ + "img/Bank Pocztowy .c4ecd4c6.png";